import MessageBox from "./message-box";
import ConfirmationMessageBox from "./confirmation-box";
const exportedObject = {
  MessageBox,
  ConfirmationMessageBox,
};
export default exportedObject;
